import { render, staticRenderFns } from "./View22.vue?vue&type=template&id=4da70c58&scoped=true&"
import script from "./View22.vue?vue&type=script&lang=js&"
export * from "./View22.vue?vue&type=script&lang=js&"
import style0 from "./View22.vue?vue&type=style&index=0&id=4da70c58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da70c58",
  null
  
)

export default component.exports